export default __webpack_public_path__ + "static/B0150-b78d165a3df0dfeaad8390784531dc91.png";